/** Trustpilot's star mark, drawn inline so there is no third-party script or logo file. */
export const TrustpilotStar = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" role="img" aria-label="Trustpilot reviews" className={className}>
    <circle cx="12" cy="12" r="12" fill="#00B67A" />
    <path d="M12 4.6l2.1 4.6h4.7l-3.9 3 1.5 4.6-4.4-2.9-4.4 2.9 1.7-5-3.7-2.6h4.6z"
          fill="#00301C" />
  </svg>
);
